"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = require("redux");

var _reactRouterRedux = require("react-router-redux");

var _reduxForm = require("redux-form");

var _reactIntlRedux = require("react-intl-redux");

var _booking = require("./booking");

var _booking2 = _interopRequireDefault(_booking);

var _bookingServices = require("./bookingServices");

var _bookingServices2 = _interopRequireDefault(_bookingServices);

var _transferServices = require("./transferServices");

var _transferServices2 = _interopRequireDefault(_transferServices);

var _linkedBookings = require("./linkedBookings");

var _linkedBookings2 = _interopRequireDefault(_linkedBookings);

var _bookingMeta = require("./bookingMeta");

var _bookingMeta2 = _interopRequireDefault(_bookingMeta);

var _primaryCustomer = require("./primaryCustomer");

var _primaryCustomer2 = _interopRequireDefault(_primaryCustomer);

var _user = require("./user");

var _user2 = _interopRequireDefault(_user);

var _requirementSets = require("./requirementSets");

var _requirementSets2 = _interopRequireDefault(_requirementSets);

var _requirements = require("./requirements");

var _requirements2 = _interopRequireDefault(_requirements);

var _checkinUrls = require("./checkinUrls");

var _checkinUrls2 = _interopRequireDefault(_checkinUrls);

var _customers = require("./customers");

var _customers2 = _interopRequireDefault(_customers);

var _departureServices = require("./departureServices");

var _departureServices2 = _interopRequireDefault(_departureServices);

var _profiles = require("./profiles");

var _profiles2 = _interopRequireDefault(_profiles);

var _apiCalls = require("./apiCalls");

var _apiCalls2 = _interopRequireDefault(_apiCalls);

var _reduxUi = require("redux-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// state is a regular JS object
// state.requirementSets is an immutable List
var gRexApp = (0, _redux.combineReducers)({
    booking: _booking2.default,
    bookingServices: _bookingServices2.default,
    transferService: _transferServices2.default,
    linkedBookings: _linkedBookings2.default,
    bookingMeta: _bookingMeta2.default,
    primaryCustomer: _primaryCustomer2.default,
    user: _user2.default,
    requirementSets: _requirementSets2.default,
    requirements: _requirements2.default,
    checkinUrls: _checkinUrls2.default,
    customers: _customers2.default,
    departureServices: _departureServices2.default,
    profiles: _profiles2.default,
    apiCalls: _apiCalls2.default,
    form: _reduxForm.reducer,
    routing: _reactRouterRedux.routerReducer,
    intl: _reactIntlRedux.intlReducer,
    ui: _reduxUi.reducer
}); // Exports the root reducer

exports.default = gRexApp;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/index.js
// module id = 1398
// module chunks = 0